/**
 * Dependencies.
 */
import { configurationService } from '@/api/configuration/configuration.service';

/**
 * Get distribution center configuration.
 */
const getDistributionCenterRadius = async () => {
  let distributionCenterRadius = null;

  try {
    const resConfigDc = await configurationService.getDistributionCenterRadius();
    const { value: radius } = resConfigDc || {};

    distributionCenterRadius = radius
      ? { distributionCenterRadius: Number(radius) }
      : null;
  } catch (error) {
    if (process.env.BUILD_MODE !== 'prd') {
      console.error(error);
    }
  }

  return distributionCenterRadius;
};

/**
 * Get minimum product expiration.
 */
const getMinimumProductExpiration = async () => {
  let minimumProductExpiration = null;

  try {
    const resConfigDc = await configurationService.getMinimumProductExpiration();
    const { value: minimum } = resConfigDc || {};

    minimumProductExpiration = minimum
      ? { minimumProductExpiration: Number(minimum) }
      : null;
  } catch (error) {
    if (process.env.BUILD_MODE !== 'prd') {
      console.error(error);
    }
  }

  return minimumProductExpiration;
};

/**
 * Get the number of maximum requests.
 */
const getRequestMaximum = async () => {
  let requestMaximum = { requestMaximum: 3 };

  try {
    const resConfigDc = await configurationService.getRequestMaximum();
    const { value: maximum } = resConfigDc || {};

    requestMaximum = maximum ? { requestMaximum: Number(maximum) } : null;
  } catch (error) {
    if (process.env.BUILD_MODE !== 'prd') {
      console.error(error);
    }
  }

  return requestMaximum;
};

/**
 * Initialize configuration.
 */
const init = async ({
  refresh = null
}: {
  refresh?: {
    distributionCenterRadius?: boolean;
    minimumProductExpiration?: boolean;
    requestMaximum?: boolean;
  };
} = {}) => {
  const refreshAll = refresh === null ? true : false;
  const {
    distributionCenterRadius: refreshDistributionCenterRadius = false,
    minimumProductExpiration: refreshMinimumProductExpiration = false,
    requestMaximum: refreshRequestMaximum = false
  } = refresh || {};

  let configurationData: {
    distributionCenterRadius?: number;
    minimumProductExpiration?: number;
    requestMaximum?: number;
  } = {
    distributionCenterRadius: null
  };

  if (refreshDistributionCenterRadius || refreshAll) {
    configurationData = {
      ...configurationData,
      ...(await getDistributionCenterRadius())
    };
  }

  if (refreshMinimumProductExpiration || refreshAll) {
    configurationData = {
      ...configurationData,
      ...(await getMinimumProductExpiration())
    };
  }

  if (refreshRequestMaximum || refreshAll) {
    configurationData = {
      ...configurationData,
      ...(await getRequestMaximum())
    };
  }

  return configurationData;
};

/**
 * Configuration.
 */
const configuration = {
  getDistributionCenterRadius,
  getMinimumProductExpiration,
  getRequestMaximum,
  init
};

/**
 * Export configuration.
 */
export default configuration;
